import { ProductData } from 'utils/types';
import { AutoTextSize } from 'utils/autoTextSizeUtils';
import { StyledMainProduct } from './style';
import { Box } from '@mui/material';

interface SubRollingOfferMainProductProps extends ProductData {
  isHorizontalViewActive: boolean;
}
export const SubRollingOfferMainProduct: React.FC<
  SubRollingOfferMainProductProps
> = ({
  quantityDisplay,
  images = { product: '' },
  strokedSaleQuantity,
  salePercentage = 0,
  textFontColorHex,
  isHorizontalViewActive,
}) => {
  return (
    <StyledMainProduct
      className="main-product"
      title={quantityDisplay}
      color={textFontColorHex}
      isHorizontalViewEnabled={isHorizontalViewActive}
    >
      <Box className="product-image-container">
        <div className="main-product-image">
          {images.product && (
            <img className="product" src={images.product} alt="main product" />
          )}
        </div>
      </Box>
      <div className="text">
        <>
          <AutoTextSize
            maxFontSizePx={16}
            minFontSizePx={2}
            as="p"
            className="quantity"
            mode="oneline"
          >
            {quantityDisplay}
          </AutoTextSize>
          {salePercentage > 0 && (
            <AutoTextSize
              maxFontSizePx={isHorizontalViewActive ? 12 : 10}
              minFontSizePx={1}
              as="p"
              className="stroked"
              mode="oneline"
            >
              {strokedSaleQuantity}
            </AutoTextSize>
          )}
        </>
      </div>
    </StyledMainProduct>
  );
};
